
    import Vue from 'vue';
    import { BatchExportFileService } from "@/services/BatchExportFileService"
    import { ContributionPeriodService } from "@/services/ContributionPeriodService"
    import { SnackbarService } from "@/services/SnackbarService";
    import SelectListItem from '../../models/SelectListItem';
    import BatchExportFileDisplay from '../../models/api/association/ExportFileDisplay';
    import { DataTableHelper } from '../../helpers/DataTableHelper';
    import { BatchStates } from '../../models/Enums';
    import DeleteDialog from '@/components/dialogs/DeleteDialog.vue';
    import PeriodStats from '../../models/api/association/PeriodStats';
    import { mapGetters } from 'vuex';

    export default Vue.extend({
        components: {
            DeleteDialog
        },
       data() {
            return {
                contributionPeriods: [] as SelectListItem[],
                contributionPeriodsRegistration: [] as SelectListItem[],
                selectedContributionPeriod: -1,
                pageHeader: this.$vuetify.lang.t('$vuetify.batch.statisticsAndExport'),
                totalCount: 0,
                items: [] as BatchExportFileDisplay[],
                isTableLoading: true,
                options: {},
                tableHeaders: [
                    {
                        text: 'id',
                        sortable: false,
                        value: 'id',
                    },
                    {
                        text: 'contributionPeriod.contributionPeriod',
                        sortable: false,
                        value: 'contributionPeriodName'
                    },
                    {
                        text: 'created',
                        sortable: false,
                        value: 'created',
                    },
                    {
                        text: 'group.groups',
                        sortable: false,
                        value: 'numberOfGroups',
                    },
                    {
                        text: 'occasion.occasions',
                        sortable: false,
                        value: 'numberOfOccasions',
                    },
                    {
                        text: 'occasion.participants',
                        sortable: false,
                        value: 'numberOfParticipants',
                    },
                    {
                        text: 'occasion.leaders',
                        sortable: false,
                        value: 'numberOfLeaders',
                    },
                    {
                        text: ':NL',
                        sortable: false,
                        align: 'center',
                        value: 'downloaded',
                    },
                    {
                        text: ':H',
                        sortable: false,
                        align: 'center',
                        value: 'fetched',
                    },
                    {
                        text: 'batch.batchState',
                        sortable: false,
                        value: 'batchState',
                    },
                    {
                        text: '',
                        sortable: false,
                        value: 'actions'
                    },
                ],
                // Delete dialog
                showDelete: false,
                itemToDeleteId: "",
                itemToDeleteName: "",

                disableAddBatchJobButton: false,

                periodStats: {} as PeriodStats,
                totalCountStats: 0,
                isTableLoadingStats: true,
                tableHeadersStats: [
                    {
                        text: 'group.groupName',
                        sortable: false,
                        value: 'name',
                    },
                    {
                        text: 'occasion.confirmed',
                        sortable: false,
                        value: 'numberOfConfirmedOccasions'
                    },
                    {
                        text: 'occasion.unconfirmed',
                        sortable: false,
                        value: 'numberOfUnconfirmedOccasions'
                    },
                    {
                        text: 'occasion.coming',
                        sortable: false,
                        value: 'numberOfComingOccasions'
                    },
                ],

                showMessage: false,
                message: "",
            }
        },
        created() {
            DataTableHelper.adaptTableHeaders(this.tableHeaders, this);
            DataTableHelper.adaptTableHeaders(this.tableHeadersStats, this);
            this.getItemsPaged();
            this.$store.commit('addOverlay');
            ContributionPeriodService.GetSelectListItems().then(response => {
                this.contributionPeriods = response.data;
                if (this.contributionPeriods.length > 0) {
                    this.selectedContributionPeriod = this.contributionPeriods[0].value as number;
                    this.getPeriodInformation();
                }
            }).catch((error) => {
                SnackbarService.addErrorMessage(
                    error.response?.data || error.response?.statusText
                );
            })
            .finally(() => {
                this.$store.commit('removeOverlay');
            });
            ContributionPeriodService.GetRegistrationSelectListItems().then(response => {
                this.contributionPeriodsRegistration = response.data;
            }).catch((error) => {
                SnackbarService.addErrorMessage(
                    error.response?.data || error.response?.statusText
                );
            })
            .finally(() => {
                this.$store.commit('removeOverlay');
            });
            this.timerGetWorkingBatches();
        },
        watch: {
            options: {
                handler() {
                    this.getItemsPaged();
                },
                deep: true,
            },
            selectedContributionPeriod: {
                handler() {
                    this.getPeriodInformation();
                }
            },
            items: {
                handler() {
                    this.disableAddBatchJobButton = this.items.some((s: BatchExportFileDisplay) => s.batchState == BatchStates.Pending || s.batchState == BatchStates.Running);
                },
                deep: true,
            },
        },
        computed: {
            ...mapGetters([
                "isSystemAdmin",
                "isMunicipalityAdmin",
            ]),
        },
        methods: {
            canExportFile(): boolean {
                if (!this.selectedContributionPeriod) {
                    return false;
                }
                return this.contributionPeriodsRegistration.some(s => typeof s.value == 'string' ? s.value == this.selectedContributionPeriod.toString() : s.value as number == this.selectedContributionPeriod);
            },
            async getPeriodFileFlags() {
                if (this.selectedContributionPeriod) {
                    BatchExportFileService.GetPeriodFileFlags(this.selectedContributionPeriod).then(response => {
                        this.periodStats.hasExportFile = response.data.hasExportFile;
                        this.periodStats.isExportFileLocked = response.data.isExportFileLocked;
                    }).catch((error) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    })
                    .finally(() => {
                    });
                }
            },
            async getPeriodInformation() {
                if (this.selectedContributionPeriod) {
                    this.isTableLoadingStats = true;
                    this.$store.commit('addOverlay');
                    BatchExportFileService.GetPeriodStats(this.selectedContributionPeriod).then(response => {
                        this.periodStats = response.data;
                    }).catch((error) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    })
                    .finally(() => {
                        this.isTableLoadingStats = false;
                        this.$store.commit('removeOverlay');
                    });
                } else {
                    this.periodStats = {} as PeriodStats;
                }
            },
            async deleteBatch(item: BatchExportFileDisplay) {
                this.itemToDeleteId = item.id.toString();
                this.itemToDeleteName = item.contributionPeriodName;
                this.showDelete = true;
            },
            async deleteCallback(itemToDeleteId: string) {
                this.showDelete = false;
                if (itemToDeleteId) {
                    this.$store.commit('addOverlay');
                    BatchExportFileService.DeleteBatchJob(parseInt(itemToDeleteId)).then(() => {
                        this.getItemsPaged();
                        // Some updates might have affected periods flags
                        this.getPeriodFileFlags();
                    })
                    .catch((error) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    })
                    .finally(() => {
                        this.$store.commit('removeOverlay');
                    });
                }
            },
            isBusy(item: BatchExportFileDisplay): Boolean {
                return item.batchState == BatchStates.Pending || item.batchState == BatchStates.Running;
            },
            getBatchStateName(val: BatchStates) {
                return BatchStates[val];
            },
            updateItemsByIds(idsString: string): void {
                BatchExportFileService.GetBatchJobsByIds(idsString).then(response => {
                    const fetchedItems = response.data;
                    fetchedItems.forEach((s: BatchExportFileDisplay) => this.items.filter((t: BatchExportFileDisplay) => t.id == s.id).forEach((t: BatchExportFileDisplay) => {
                        t.modified = s.modified;
                        t.batchState = s.batchState;
                        t.fileName = s.fileName;
                        t.numberOfGroups = s.numberOfGroups;
                        t.numberOfOccasions = s.numberOfOccasions;
                        t.numberOfParticipants = s.numberOfParticipants;
                        t.numberOfLeaders = s.numberOfLeaders;
                        t.fetched = s.fetched;
                        t.downloaded = s.downloaded;
                        t.message = s.message;
                    }));
                    // Some updates might have affected periods flags
                    this.getPeriodFileFlags();
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    setTimeout(() => {
                        this.timerGetWorkingBatches();
                    }, 2000);
                });
            },
            timerGetWorkingBatches(): void {
                const idsString = this.items.filter((s: BatchExportFileDisplay) => s.batchState == BatchStates.Pending || s.batchState == BatchStates.Running).map((s: BatchExportFileDisplay) => s.id.toString()).join(",");
                if (idsString) {
                    this.updateItemsByIds(idsString);
                } else {
                    setTimeout(() => {
                        this.timerGetWorkingBatches();
                    }, 5000);
                }
            },
            getItemsPaged(): void {
                this.isTableLoading = true;
                const sortBy = (this.options as any).sortBy ?? [];
                const sortDesc = (this.options as any).sortDesc ?? [];
                const page = (this.options as any).page ?? 1;
                const itemsPerPage = (this.options as any).itemsPerPage ?? 10;
                const data = { sortBy: sortBy, sortDesc: sortDesc, page: page, itemsPerPage: itemsPerPage };
                BatchExportFileService.GetBatchJobsPaged(data).then(response => {
                    this.totalCount = response.data.totalCount;
                    this.items = response.data.items;
                }).catch((error) => {
                    console.error(error);
                }).finally(() => {
                    this.isTableLoading = false;
                });
            },
            async getExportFile(batchId: number) {
                this.$store.commit('addOverlay');
                await BatchExportFileService.GetFile(batchId);
                this.updateItemsByIds(batchId.toString());
                this.$store.commit('removeOverlay');
            },
            generateExportFile(): void {
                this.$store.commit('addOverlay');
                BatchExportFileService.AddBatchJob(this.selectedContributionPeriod).then(result => {
                    this.getItemsPaged();
                    // Some updates might have affected periods flags
                    this.getPeriodFileFlags();
                })
                .catch((error) => {
                    SnackbarService.addErrorMessage(
                        error.response?.data || error.response?.statusText
                    );
                })
                .finally(() => {
                    this.$store.commit('removeOverlay');
                });
        }
        },
    })
